import { useEffect, useState } from "react";
import * as API from './api/api-admin';

import './Admin.css';

import imgBackIcon from './img/back-icon.png';
import imgRefreshIcon from './img/refresh-icon.png';
import imgQuestionIcon from './img/question-icon.png';
import imgAnswersIcon from './img/answers-icon.png';

export default function Admin() {

    const [userToken, setUserToken] = useState(localStorage.getItem('userToken'));
    const [adminToken, setAdminToken] = useState(localStorage.getItem('adminToken'));

    const [ sessionList, setSessionList ] = useState(null);
    const [ selectedSession, setSelectedSession ] = useState(null);
    const [ sessionData, setSessionData ] = useState(null);
    const [ accessCode, setAccessCode ] = useState('');
    const [ showImagePopup, setShowImagePopup ] = useState(false);
    const [ popupImageUrl, setPopupImageUrl ] = useState('');
    const [ showAnswersPopup, setShowAnswersPopup ] = useState(false);
    const [ popupUserAnswersData, setPopupUserAnswersData ] = useState(null);
    const [ showQuestions, setShowQuestions ] = useState(false);

    const [firstName, setFirstName] = useState(localStorage.getItem('firstName') ||  null);

    useEffect(() => {
        if(sessionList === null) {
            API.AdminSessionsList().then(data => {
                console.log('AdminSessionsList API response:', data);
                setSessionList(data.Items || []); 
            }).catch(err => {
                console.error('Error fetching sessions:', err);
                setSessionList([]); 
            });
        }
    }, [sessionList]);


    function handleSessionDetails(sessionId) {
        setSelectedSession(sessionId);
    }

    function GetSelectedItem() {
        if(selectedSession) {
            return sessionList.find(session => session.Id === selectedSession);
        }        
        return {};
    }

    function GetCorrectAnswer(question) {
        if (!sessionData || !sessionData.Answers) return '';
        const correctItem = sessionData.Answers.find(item => item.Question === question);
        return correctItem ? correctItem.CorrectAnswers : '';
    }

    useEffect(() => {
        if (selectedSession) {
            LoadSessionData()
        }
    }, [selectedSession]);

    function handleChangeSessionStatus() {
        API.AdminChangeSessionStatus(selectedSession).then(data => {
            setAccessCode(data.AccessCode || '');
        }).catch(err => {
            console.error('Error changing session status:', err);
        });
    }

    function handleRefreshSession() {
        LoadSessionData()
    }

    function LoadSessionData() {
        if (selectedSession) {
            API.AdminSessionDetails(selectedSession).then(data => { 
                setSessionData(data);
                setAccessCode(data.AccessCode || '');
            }).catch(err => {
                console.error('Error fetching session details:', err);
                setSessionData(null); 
            });
        }
    }


    function formatTime(seconds) {
        if(seconds === '' || isNaN(seconds) || seconds < 0) {
            return '--:--';
        }
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }

    function handleSetTimer() {
        const newTime = prompt('Enter new timer value (mm:ss):', formatTime(sessionData.Duration));  
        if (newTime) {
            // convert mm:ss to seconds
            const parts = newTime.split(':');
            if(parts.length === 2) {
                const mins = parseInt(parts[0]);
                const secs = parseInt(parts[1]);
                if(!isNaN(mins) && !isNaN(secs) && mins >= 0 && secs >= 0 && secs < 60) {
                    const totalSeconds = mins * 60 + secs;
                    setSessionData({...sessionData, Duration: totalSeconds});

                    API.AdminSetSessionDuration(sessionData.SessionId, totalSeconds).then(data => {
                        LoadSessionData();
                    }).catch(err => {
                        console.error('Error setting session timer:', err);
                    });
                }
            }
        }
    }

    function GetCorrectAnswer(question) {
        if(sessionData.Questions && sessionData.Questions.length > 0) {
            const correct = sessionData.Questions.find(q => q.Question === question);
            return correct ? correct.CorrectAnswers : '';
        }
        return '';
    }

    function GetRankPositionColor(rank){
        if (rank === 1) return '#ffd700'; // gold
        if (rank === 2) return '#c0c0c0'; // silver
        if (rank === 3) return '#cd7f31'; // bronze
        return 'inherit';
    }

    function handleUserConfirmation(user) {
        API.AdminConfirmUser(sessionData.SessionId, user.IdUser, !user.Confirmed).then(data => {
            LoadSessionData();
        }).catch(err => {
            console.error('Error confirming user:', err);
        });
    }

    function askForLogout() {
      if (window.confirm('Are you sure you want to log out?')) {
        setFirstName(null);
        //setLastName(null);
        //setClassName(null);
        setUserToken(null);
        setAdminToken(null);
        //setSessionCode('');
        //setSessionData(null);
        localStorage.removeItem('firstName');
        localStorage.removeItem('lastName');
        localStorage.removeItem('className');
        localStorage.removeItem('userToken');
        localStorage.removeItem('adminToken');
        localStorage.removeItem('sessionCode');

        window.location.href = '/';
      }
    }

  return (
    <>
    <div id="header">
        {firstName && (<div id="user-name" onClick={askForLogout}>{firstName}</div>)}
    </div>

    <div className="form-container form-container-500 white-background padding20">
        { /*
        <h2>Admin Panel</h2>
        <p style={{ textAlign: 'center' }}>Here you can manage sessions and view results.</p>
         */}
        { selectedSession && sessionData && (
            <div className="session-details">
                <h2>{sessionData.Description}</h2>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '30px', marginBottom: '20px' }}>
                    <button className="btn-nav-admin" onClick={() => setSelectedSession(null)}><img src={imgBackIcon} alt="Back" /></button>
                    <button className="btn-access-code" onClick={handleSetTimer}>{formatTime(sessionData.Duration)}</button>
                    <button className={`btn-access-code ${accessCode ? 'session-active' : 'session-inactive'}`} onClick={handleChangeSessionStatus}>
                        {accessCode ? accessCode : 'Start'}
                    </button>
                    <button className="btn-nav-admin" onClick={handleRefreshSession}><img src={imgRefreshIcon} alt="Refresh" /></button>
                </div>


                <div>
                    {sessionData && sessionData.Users && sessionData.Users.length > 0 ? (
                        <div>
                            <table className="results-table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Name</th>
                                        <th>Points</th>
                                        <th>Time</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {sessionData.Users.map((user, index) => (
                                        <tr key={index} >
                                            <td style={{ backgroundColor: GetRankPositionColor(user.RankPosition) }}>{user.RankPosition}</td>
                                            <td>{user.Name}
                                                {user.RankPosition < 4 && (<div style={{float: 'right'}}>
                                                    <input type="checkbox" checked={user.Confirmed} onChange={() => {handleUserConfirmation(user); }} /> 
                                                </div>)}
                                                <div style={{fontSize: 'smaller', textAlign: 'right'}}>{user.ClassName} - {user.StudentId}</div></td>
                                            <td>{user.Points}</td>
                                            <td style={{ color: user.Duration > sessionData.Duration ? 'red' : 'green', fontWeight: user.Duration > sessionData.Duration ? 'normal' : 'bold' }}>
                                                {formatTime(user.Duration)}
                                            </td>
                                            <td><button className="btn-nav-admin" onClick={() => { setPopupUserAnswersData(user); setShowAnswersPopup(true); }}><img src={imgAnswersIcon} alt="View Image" /></button></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            
                        </div>
                    ) : (
                        <p>No user data available.</p>
                    )}
                </div>

                <div>
                            <br /><br/>
                    <button style={{height: '40px'}} onClick={() => setShowQuestions(!showQuestions)}>Questions</button>
                    {showQuestions && sessionData && sessionData.Questions && sessionData.Questions.length > 0 ? (
                        <div>
                            <div style={{textAlign: 'center'}}>Max/min points: <b>{sessionData.Points} / {sessionData.MinPoints}</b></div>
                            <table className="results-table">
                                <thead>
                                    <tr>
                                        <th>Question</th>
                                        <th>Answers</th>
                                        <th>Points</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {sessionData.Questions.map((question, index) => (
                                        <tr key={index}>
                                            <td>{question.Question}</td>
                                            <td>{question.CorrectAnswers}</td>
                                            <td>{question.Points}</td>
                                            <td><button className="btn-nav-admin" onClick={() => { setPopupImageUrl(question.Image); setShowImagePopup(true); }}><img src={imgQuestionIcon} alt="View Image" /></button></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : showQuestions ? (
                        <p>No answer data available.</p>
                    ) : null}
                </div>
            </div>
        )}

        { !selectedSession && (
            <>
                {sessionList === null ? (
                    <p style={{ textAlign: 'center' }}>Loading sessions...</p>
                ) : sessionList.length === 0 ? (
                    <p style={{ textAlign: 'center' }}>No sessions found.</p>
                ) : (
                    <>
                        {sessionList.map((session, index) => (
                            <div key={index} className="session-item" onClick={() => handleSessionDetails(session.Id)}> 
                                <strong>{session.Description}</strong>  <div className="session-item-status"> {session.Status}</div>
                            </div>
                        ))}
                    </>
                )}

                    <br /><br /><br />
 
                <input type="file" id="fileInput" style={{ display: 'none' }} onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                        API.AdminUploadFile(file).then(data => {
                            setSessionList(null); 
                        }).catch(err => {
                            console.error('Error uploading session:', err);
                            setSessionList([]); 
                        });
                    }
                }} />

                <button type="button" className="btn-height45" onClick={() => document.getElementById('fileInput').click()}>
                    Add file
                </button>
            </>
            
        ) }



        {showImagePopup && (
            <div className="image-popup-overlay" onClick={() => setShowImagePopup(false)}>
                <div className="image-popup-content" onClick={(e) => e.stopPropagation()}>
                    <button className="close-button" onClick={() => setShowImagePopup(false)}>X</button>
                    <img src={popupImageUrl} alt="Answer Image" style={{maxWidth: '100%', maxHeight: '80vh'}} />
                </div>
            </div>
        )}

        {showAnswersPopup && (
            <div className="image-popup-overlay" onClick={() => setShowAnswersPopup(false)}>
                <div className="image-popup-content" onClick={(e) => e.stopPropagation()}>
                    <button className="close-button" onClick={() => setShowAnswersPopup(false)}>X</button>
                    
                    <h3>{popupUserAnswersData.Name}</h3>
                    {popupUserAnswersData.Answers && popupUserAnswersData.Answers.length > 0 ? (
                        <table className="results-table">
                            <thead>
                                <tr>
                                    <th># Q</th>  
                                    <th>Correct answer</th> 
                                    <th>Given answer</th>
                                    <th>Points</th>
                                </tr>   
                            </thead>
                            <tbody>
                                {popupUserAnswersData.Answers.map((answer, index) => (  
                                    <tr key={index} style={{ color: answer.Answers === GetCorrectAnswer(answer.Question) ? 'green' : 'red', fontWeight: answer.Answers === GetCorrectAnswer(answer.Question) ? 'bold' : 'normal' }}>
                                        <td>{answer.Question}</td>
                                        <td>{GetCorrectAnswer(answer.Question)}</td>
                                        <td>{answer.Answers}</td>
                                        <td>{answer.Points}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <p>No answers data available.</p>
                    )}

                </div>
            </div>
        )}  

    </div>
    </>
  );
}